import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Tabs,
  Box,
  Tab,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createReginationRequest } from "../../api/resignation";
import { handleAxiosError } from "../../config/action-config";
import { showAlert } from "../../actions/alert";
import { getUser } from "../../actions/auth";
import EmployeeResignationDetails from "../profile/resignation.detail.tab";
import TabPanel from "../../component/TabPanel";
import { Link, useNavigate } from "react-router-dom";
import EmployeeKTChecklist from "./employee.checklist";

export default function EmployeeResignation() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [currentStatus, setCurrentStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(
    user.resignation_initiated === false || user.resignation_initiated === null
      ? 0
      : 1
  );
  const navigate = useNavigate();
  const [resignationDetails, setResignationDetails] = useState({
    first_name: user.firstname,
    last_name: user.lastname,
    email: user.email,
    designation: user.designation,
    resignation_reason: "",
    notice_period_in_days: "60",
    remarks: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setResignationDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const onfirmSubmit = async () => {
    try {
      const res = await createReginationRequest(resignationDetails, user.token);
      dispatch(getUser(user.token));
      dispatch(showAlert(res.data.msg));
      setTabIndex(1);
      setOpen(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  useEffect(() => {
    calculateDaysLeft();
  }, []);
  function calculateDaysLeft() {
    const lockDate = new Date(user.lock_in_date);
    const currentDate = new Date();
    const differenceMs = lockDate - currentDate;
    const daysLeft = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
    console.log("dayyy==", daysLeft);
    return daysLeft;
  }

  return (
    <>
      {user.lock_in_date === null ? (
        <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            aria-label="basic tabs example"
          >
            {user.resignation_initiated === false ||
            user.resignation_initiated === null ? (
              <Tab
                label="Exit Process"
                id="simple-tab-0"
                aria-controls="simple-tabpanel-0"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            ) : (
              <></>
            )}
            {user.resignation_initiated === true ? (
              <Tab
                label="Resignation Details"
                id="simple-tab-3"
                aria-controls="simple-tabpanel-3"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            ) : (
              <></>
            )}
            {currentStatus === "ACCEPTED FOR FURTHER STEPS" ? (
              <Tab
                label={`Checklist`}
                id="simple-tab-2"
                aria-controls="simple-tabpanel-2"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            ) : (
              <></>
            )}
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            {/* {user.resignation_initiated === true ? (
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="error">
              <Box sx={{ mt: 1 }} fontStyle="normal">
                You have already submitted your request for Resignation. Click
                on Resignation Details tab to check the status.
              </Box>
            </Typography>
          </Paper>
        ) : ( */}
            {user.resignation_initiated === false ||
            user.resignation_initiated === null ? (
              <Paper component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      autoFocus
                      disabled
                      margin="dense"
                      id="first_name"
                      name="first_name"
                      label="First Name"
                      fullWidth
                      value={resignationDetails.first_name}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      disabled
                      id="last_name"
                      name="last_name"
                      label="Last Name"
                      fullWidth
                      value={resignationDetails.last_name}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      id="email"
                      name="email"
                      label="Email"
                      fullWidth
                      value={resignationDetails.email}
                      onChange={handleInputChange}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      disabled
                      id="notice_period_in_days"
                      name="notice_period_in_days"
                      label="Notice Period (in days)"
                      fullWidth
                      value={resignationDetails.notice_period_in_days}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="designation"
                      name="designation"
                      label="Designation"
                      fullWidth
                      value={resignationDetails.designation}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="resignation_reason"
                      name="resignation_reason"
                      label="Reason for Resignation"
                      required
                      fullWidth
                      multiline
                      rows={4}
                      value={resignationDetails.resignation_reason}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="remarks"
                      name="remarks"
                      label="Remarks"
                      fullWidth
                      multiline
                      rows={4}
                      value={resignationDetails.remarks}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "right",
                      columnGap: 1,
                      m: 1,
                    }}
                  >
                    <Button
                      onClick={() => {
                        navigate("/profile");
                      }}
                      className="cancel-button"
                    >
                      Cancel
                    </Button>
                    {user.lock_in_date === null && (
                      <Button type="submit" className="blue-button">
                        Submit
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Paper>
            ) : (
              <></>
            )}
            {/* )} */}
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <Paper>
              {user.resignation_initiated === true && (
                <EmployeeResignationDetails
                  setCurrentStatus={setCurrentStatus}
                />
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <Paper>
              {user.resignation_initiated === true && tabIndex === 2 && (
                <EmployeeKTChecklist />
              )}
            </Paper>
          </TabPanel>
          <Dialog
            open={open}
            onClose={() => {
              // setOpen(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Confirm Resignation
            </DialogTitle>
            <DialogContent style={{ width: "500px" }}>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to resign?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpen(false);
                }}
                className="cancel-button"
              >
                Cancel
              </Button>
              <Button
                type="button"
                onClick={onfirmSubmit}
                className="add-button btn-align-right"
              >
                Sure
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      ) : (
        <div className="page d-flex">
          <div className="m-auto text-center">
            <Typography variant="h5">
              You are unable to access this page before {calculateDaysLeft()}
              days.
            </Typography>
            <br />
            <Link to="/">
              <Button variant="contained">Back To Home</Button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
